import { render, staticRenderFns } from "./additional_document.vue?vue&type=template&id=e4bb8976&"
import script from "./additional_document.vue?vue&type=script&lang=js&"
export * from "./additional_document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports